import React from 'react';

const FiverrFreelancers = () => (
    <svg width={407} height={322} viewBox="0 0 407 322" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.567 289.368h390.018M166.239 76.006c4.299 0 7.784-3.488 7.784-7.791 0-4.304-3.485-7.792-7.784-7.792-4.299 0-7.784 3.488-7.784 7.792 0 4.303 3.485 7.791 7.784 7.791ZM242.948 86.895c4.299 0 7.784-3.489 7.784-7.792s-3.485-7.791-7.784-7.791c-4.298 0-7.783 3.488-7.783 7.791 0 4.303 3.485 7.792 7.783 7.792ZM81.4 87.526a7.795 7.795 0 0 1-5.973 2.79 7.788 7.788 0 0 1-5.972-2.79M327.513 81.72c4.299 0 7.784-3.488 7.784-7.791 0-4.304-3.485-7.792-7.784-7.792-4.299 0-7.784 3.488-7.784 7.791 0 4.304 3.485 7.792 7.784 7.792Z"
            stroke="#232426"
            strokeWidth={1.5}
            strokeMiterlimit={10}
        />
        <path
            d="M155.688 113.142a5.588 5.588 0 0 0 5.586-5.591 5.589 5.589 0 0 0-5.586-5.592 5.589 5.589 0 0 0-5.586 5.592 5.588 5.588 0 0 0 5.586 5.591Z"
            fill="#B8B6F6"
        />
        <path
            d="M56.898 153.363 41.158 266.94l23.158 1.008 14.398-82.582h1.373l10.765 82.582h22.029l-11.284-116.296M328.347 66.178c.357 2.19-2.645 6.233-4.853 7.272a11.677 11.677 0 0 1-3.744 1.13"
            stroke="#232426"
            strokeWidth={1.5}
            strokeMiterlimit={10}
        />
        <path
            d="M328.052 68.093c.326 1.548 4.223 5.215 7.031 5.54"
            stroke="#232426"
            strokeWidth={1.5}
            strokeMiterlimit={10}
        />
        <path
            d="M304.233 94.198a9.476 9.476 0 0 1 3.693-11.071c2.686-1.58 6.37-.846 8.527-8.088 2.157-7.242 6.461-9.778 10.175-9.961 3.714-.183 7.702 1.456 10.612 7.527 2.91 6.07 5.017 5.093 8.73 5.867a6.76 6.76 0 0 1 4.55 3.263 6.776 6.776 0 0 1 .538 5.577"
            stroke="#232426"
            strokeWidth={1.5}
            strokeMiterlimit={10}
        />
        <path
            d="M319.749 74.58c-.274 2.903 1.13 6.427-4.629 9.86-5.759 3.432-5.088 7.241-5.088 7.241M334.879 76.455c.306 1.874 1.659 3.942 5.088 4.838 3.429.896 5.006 1.833 5.576 4.97"
            stroke="#232426"
            strokeWidth={1.5}
            strokeMiterlimit={10}
        />
        <path
            d="M158.527 67.084c2.401.397 7.244-2.658 8.425-5.999 1.18-3.34-7.347 2.495-7.347 2.495l-1.078 3.504Z"
            fill="#232426"
        />
        <path
            d="M166.514 60.403c-.051 1.772-.142 4.532 2.208 5.897a5.632 5.632 0 0 0 5.159.428 5.62 5.62 0 0 0-3.144-4.869c-3.287-1.803-4.223-1.456-4.223-1.456ZM166.494 60.209c4.079 0 7.387-3.31 7.387-7.395 0-4.083-3.308-7.394-7.387-7.394a7.391 7.391 0 0 0-7.388 7.394 7.391 7.391 0 0 0 7.388 7.395Z"
            fill="#232426"
        />
        <path
            d="M301.831 181.893c-2.35 7.425-7.774 24.679-5.708 33.041 2.065 8.362 1.974 13.353-2.91 19.647-4.884 6.295-5.444 15.41-4.976 20.299.468 4.889-3.51 7.303-3.052 12.559h28.49l17.399-101.751h1.017l13.899 102.871h31.909a30.577 30.577 0 0 0-4.385-14.045c-4.253-6.896.509-14.912 1.251-21.929.743-7.018-5.504-14.035-8.14-20.299-2.635-6.264-1.129-15.92-.875-20.554.255-4.635 2.127-11.53-2.503-19.546-4.629-8.016-6.634-10.185-6.634-17.539 0-7.354-6.837-16.001-8.516-19.179-2.88-5.449-.601-13.383.315-17.162 1.119-4.706 1.313-8.933-1.017-11.937-3.724-4.767-8.588-3.657-17.552-2.73-9.158.958-11.488 1.426-14.652 3.117-6.105 3.249-5.088 12.222-2.31 17.753 2.778 5.53 3.185 8.576.336 14.942-2.849 6.365-6.98 21.063-7.692 33.927-.051.845-.143 3.565-.143 3.565"
            stroke="#232426"
            strokeWidth={1.5}
            strokeMiterlimit={10}
        />
        <path
            d="m351.536 268.661 2.472 20.625h39.479s-.59-5.541-8.72-7.395c-8.129-1.853-12.21-2.149-13.583-6.661a33.395 33.395 0 0 1-.926-7.129M310.449 267.438l-2.615 21.848h-39.479s.59-5.541 8.71-7.395c8.12-1.853 12.261-2.149 13.594-6.661.564-2.559.854-5.171.865-7.792M148.667 146.52h39.682s7.214 25.463 7.214 52.963v66.204h-21.855l-7.774-92.105h-1.628l-17.633 93.847h-19.394s3.816-68.781 5.942-87.593c2.412-21.328 5.088-28.998 5.088-28.998s1.76-.428 6.105-1.813c4.823-1.477 4.253-2.505 4.253-2.505ZM120.777 115.067c-1.404-6.019-5.769-17.314-5.769-17.314l-14.459 6.976s-1.251-6.11-4.314-8.963c-4.13-3.88-15.598-3.137-20.838-2.821-5.76.357-19.78.947-22.731 3.84l-3.826 9.034-14.754-7.517C26.1 113.58 21.683 127.534 30.8 132.516c8.659 4.736 19.058-11.041 20.177-12.813h.254l3.053 37.247 49.613-2.037-2.218-32.358h.498s2.951 10.867 12.21 9.869a8.261 8.261 0 0 0 5.668-2.933c1.15-1.222 2.981-4.797.722-14.423Z"
            fill="#232426"
        />
        <path
            d="m50.977 120.394 49.766-3.015M51.282 126.098l50.733-2.831M51.75 131.842l50.59-2.617"
            stroke="#fff"
            strokeWidth={1.5}
            strokeMiterlimit={10}
        />
        <path
            d="m250.926 75.04-24.003 6.11s-.468-2.037.946-2.587l5.393-2.21s-.387-5.907 6.217-7.537c6.288-1.548 8.903.255 10.032 2.465a15.688 15.688 0 0 1 1.415 3.758Z"
            fill="#232426"
        />
        <path
            d="M85.348 87.69h-18.01M58.049 76.088v-2.964M61.305 87.689h-3.256v-2.893M94.556 87.69h-6.074M94.556 71.933v3.85M64.998 68.755h27.106"
            stroke="#232426"
            strokeWidth={1.5}
            strokeMiterlimit={10}
        />
        <path d="M83.272 68.754h-15.75l1.709-5.317h12.342l1.7 5.317Z" fill="#232426" />
        <path
            d="M75.397 84.613a6.271 6.271 0 0 0 6.267-6.274 6.271 6.271 0 0 0-6.267-6.275 6.271 6.271 0 0 0-6.268 6.275 6.271 6.271 0 0 0 6.268 6.274Z"
            stroke="#232426"
            strokeWidth={1.5}
            strokeMiterlimit={10}
        />
        <path
            d="M79.263 78.339a3.873 3.873 0 0 1-3.866 3.86M34.88 98.71c2.33-4.38 12.973-23.427 15.476-26.248 2.503-2.822 8.008-4.9 13.085-4.808 2.432.061 2.778 1.956-1.017 3.26a32.551 32.551 0 0 0-8.324 4.95l.123.438s8.078-.316 9.452 1.191c1.374 1.508 4.538 8.444 3.836 10.186a1.506 1.506 0 0 1-2.452 0c-.57-.887-2.615-5.52-4.386-6.519-1.404-.794-6.318-.438-6.318-.438"
            stroke="#232426"
            strokeWidth={1.5}
            strokeMiterlimit={10}
        />
        <path
            d="M48.352 105.921S56.054 86.62 56.4 85.836c.346-.785 1.231-1.64 2.188-1.019 1.129.713 4.07 5.286 5.626 4.604 1.282-.55.916-1.538.387-2.577M114.672 99.79c-2.035-4.533-11.365-24.252-13.675-27.236-2.31-2.984-8.007-11.815-10.643-11.01-2.38.682 0 4.074 1.374 6.203 2.269 3.585 5.29 8.046 5.29 8.046l-.162.428s-8.028-.856-9.503.55c-1.476 1.405-5.088 8.148-4.518 9.87a1.517 1.517 0 0 0 2.462.162c.62-.835 2.971-5.327 4.803-6.203 1.455-.692 6.339 0 6.339 0"
            stroke="#232426"
            strokeWidth={1.5}
            strokeMiterlimit={10}
        />
        <path
            d="M100.732 106.073s-6.37-19.78-6.664-20.584c-.295-.805-1.12-1.722-2.117-1.172-1.17.642-4.385 5.012-5.932 4.217-1.23-.642-.803-1.599-.203-2.597"
            stroke="#232426"
            strokeWidth={1.5}
            strokeMiterlimit={10}
        />
        <path
            d="M87.505 66.096h2.483a1.77 1.77 0 0 1 1.77 1.772v.886h-5.993v-.886a1.774 1.774 0 0 1 1.74-1.772Z"
            fill="#232426"
        />
        <path
            d="M300.803 185.172a13.13 13.13 0 0 1-7.682-7.353c-2.727-6.02-1.017-23.6.845-39.102a533.077 533.077 0 0 1 1.597-11.998c.967-6.539 2.035-12.915 3.287-18.333a69.746 69.746 0 0 1 3.052-10.654c3.287-7.986 16.433-8.933 18.936-9.167v-3.952l15.151-.754v3.759s8.506-2.19 13.136-1.019c5.087 1.304 9.157 7.201 16.218 15.472 2.198 2.607 4.264 5.092 6.044 7.404a16.302 16.302 0 0 1 1.628 17.702l-12.932 24.516c-.499 1.324-1.893 2.75.499 7.018 4.568 8.148.783 10.338.783 10.338"
            stroke="#232426"
            strokeWidth={1.5}
            strokeMiterlimit={10}
        />
        <path
            d="m347.385 106.358 13.227 12.997-6.878 20.869a4.944 4.944 0 0 0 0 4.716M341.28 102.844l-3.592-15.603 4.07-.693 5.627 19.841"
            stroke="#232426"
            strokeWidth={1.5}
            strokeMiterlimit={10}
        />
        <path
            d="M341.748 86.548s8.272-2.597 15.395 5.785c7.122 8.383 16.117 18.792 17.236 22.887 1.119 4.094-.855 11.204-3.246 15.695l-2.574 4.889-11.803-4.563 4.284-11.855-13.889-13.985-5.403-18.853ZM340.954 102.845l-3.531-15.543-1.729.57v-3.666l-14.815.703v3.656l-2.32.53v16.072s7.122-1.456 13.014-2.037a61.103 61.103 0 0 1 9.381-.285Z"
            fill="#232426"
        />
        <path
            d="m144.729 266.869-4.629 22.499h-36.498s1.628-6.009 11.895-7.761c10.266-1.752 11.396-3.636 12.393-7.649.997-4.013 1.882-9.9 1.882-9.9M176.608 263.131l2.564 26.237h38.767s-1.628-6.009-11.895-7.761c-10.267-1.752-11.386-3.636-12.393-7.649-1.008-4.013-1.872-9.9-1.872-9.9M231.054 271.89l-2.432 17.478"
            stroke="#232426"
            strokeWidth={1.5}
            strokeMiterlimit={10}
        />
        <path
            d="M215.476 270.963c-.468 2.903-.285 6.946-3.103 7.975-1.761.652-5.19 1.701-7.499 2.404M256.217 271.809l1.221 17.559M270.034 270.882c.082 2.139.367 7.965 3.053 8.81 2.686.845 9.676 1.884 9.676 1.884M260.856 158.1l5.79 112.781M229.843 158.792l-13.054 112.171M177.818 275.485h16.28M142.959 275.485h-15.507"
            stroke="#232426"
            strokeWidth={1.5}
            strokeMiterlimit={10}
        />
        <path
            d="m92.857 267.949 3.002 21.389h7.173s3.47-6.712 11.193-7.629c7.723-.917 9.391-2.516 9.391-2.516s-8.587.183-10.826-2.505c-2.523-3.056-2.9-8.77-2.9-8.77l-17.033.031ZM62.81 267.877l-3.632 21.491h-38.37s1.19-5.693 6.573-6.508c5.383-.815 14.967-1.762 15.71-4.95.743-3.188 2.035-10.797 2.035-10.797l17.684.764ZM298.941 107.999s1.944-10.92 4.996-13.313a33.167 33.167 0 0 1 10.175-5.092l.509 17.498s-7.123 3.524-2.768 14.127l-2.818 29.181-.204 2.118-16.402.316 1.435-13.404 5.077-31.431Z"
            fill="#232426"
        />
        <path d="m313.349 190.57 2.788 3.229" stroke="#232426" strokeWidth={1.5} strokeMiterlimit={10} />
        <path
            d="M280.913 153.002a1.188 1.188 0 0 1 1.679.123l1.456 1.689-1.81 1.564-1.456-1.689a1.192 1.192 0 0 1 .124-1.681l.007-.006Z"
            fill="#232426"
        />
        <path
            d="m291.727 169.222-10.134-12.426 3.022-2.608 7.082 7.772M312.464 184.785a5.729 5.729 0 0 0-3.052 1.283 4.677 4.677 0 0 0-1.71 2.812"
            stroke="#232426"
            strokeWidth={1.5}
            strokeMiterlimit={10}
        />
        <path
            d="M302.198 182.005c-1.801-1.905-5.322-4.93-4.243-8.23.722-2.21 2.564-2.373 3.968-1.13a23.546 23.546 0 0 1 2.116 2.923c2.768 3.055 8.476 9.167 8.476 9.167l2.035 7.129-6.787-3.055-5.565-6.804ZM167.603 84.145c12.21-.53 24.135 1.599 27.767 14.565 3.633 12.966 5.749 71.297 5.688 74.872-.112 6.956-.58 18.333-5.596 20.075"
            stroke="#232426"
            strokeWidth={1.5}
            strokeMiterlimit={10}
        />
        <path
            d="M197.751 119.681h-7.021l-2.971 27.368M226.668 164.252c-.061 16.724-5.535 17.641-5.535 17.641s-15.395-22.632-16.839-36.005c-1.232-11.408 1.607-27.816 6.735-38.338 5.129-10.521 19.933-14.26 36.63-15.868 8.324-.805 16.606-1.345 25.977 8.148 3.755 3.779 6.472 6.793 8.384 9.054"
            stroke="#232426"
            strokeWidth={1.5}
            strokeMiterlimit={10}
        />
        <path
            d="M222.232 158.467h45.259l4.314 112.293-16.901 1.13-10.358-84.222h-1.13L232.56 271.89l-20.655-1.13 7.244-92.096"
            stroke="#232426"
            strokeWidth={1.5}
            strokeMiterlimit={10}
        />
        <path
            d="m226.272 171.249-7.408-25.198 4.101-22.825.274.03-1.007 34.07M206.064 123.235l15.364 8.882M176.119 111.94l1.242 4.034M131.502 94.513c-2.453 1.915-5.76 11.357-5.515 20.819.244 9.462-4.07 29.221 7.57 34.854 9.29 4.512 32.56-14.759 35.022-16.358 2.463-1.599 10.857-2.862 12.454-5.867 1.598-3.004-.162-8.046-1.251-11.051-.692-1.914-3.48-.682-4.732-.101-.61.285-.274-.082-.274-.082s2.34-6.58 1.597-7.894a1.02 1.02 0 0 0-.978-.617 1.018 1.018 0 0 0-.395.098 7.658 7.658 0 0 0-2.666 2.862c-1.018 1.518-4.732 7.934-4.732 7.934l-25.366 11.031-12.078-40.018 35.949-10.857 8.842 28.855M141.015 126.098l-15.588 3.127M285.378 79.592c-.244-1.487-1.211-10.022-1.394-11.204-.315-1.976-2.279-2.414-2.961.917-.712 3.504 1.16 12.68 1.527 15.145l-.55.153a45.576 45.576 0 0 0-3.205-4.339c-1.374-1.568-3.47-3.32-4.599-1.599-1.13 1.721 3.052 7.008 5.871 12.68l2.656 26.116-8.802 9.482c5.423 6.916 13.228 15.278 19.913 12.488 6.685-2.791 5.687-18.823 3.988-26.299-1.699-7.476-3.968-29.771-3.968-29.771"
            stroke="#232426"
            strokeWidth={1.5}
            strokeMiterlimit={10}
        />
        <path
            d="M284.707 74.316c0-3.626.325-9.9 2.126-10.48 1.384-.46 1.415 1.71 1.588 5.428.173 3.718.671 9.493.671 9.493"
            stroke="#232426"
            strokeWidth={1.5}
            strokeMiterlimit={10}
        />
        <path
            d="M288.563 71.81c.336-2.322.845-5.174 1.821-5.317 1.567-.234 1.883 5.368 2.31 8.047.366 2.23 1.201 8.82 1.201 8.82M242.877 113.284l-9.575 6.437 9.209 6.193M250.763 125.914l9.564-6.437-9.208-6.193M249.043 108.365l-4.894 23.64M269.739 115.067l.01 43.42h-13.176M273.962 126.943l-4.222-5.051"
            stroke="#232426"
            strokeWidth={1.5}
            strokeMiterlimit={10}
        />
    </svg>
);
FiverrFreelancers.displayName = 'FiverrFreelancers';
export default FiverrFreelancers;
